<div class="menu-items-container">
  <div
    class="collapse-menu-btn-container"
    (click)="toggleSidebarCollapse(); $event.stopPropagation()"
    [ngClass]="{ collapsed: !dashboardMenuUncollapsed }"
  >
    <div class="ml-2">
      <div class="arrow" [ngClass]="{ right: !dashboardMenuUncollapsed, left: dashboardMenuUncollapsed }"></div>
    </div>
    @if (dashboardMenuUncollapsed) {
      <p>{{ 'navigation.collapse_menu' | transloco }}</p>
    }
  </div>
  <div class="nav-items-container" [ngClass]="{ collapsed: !dashboardMenuUncollapsed }">
    @for (item of navItems; track trackByKey($index, item)) {
      @if (item.children?.length) {
        <cdk-accordion class="accordion">
          <cdk-accordion-item #accordionItem="cdkAccordionItem" class="accordion-item">
            <div #menuItem class="menu-item" (click)="accordionItem.toggle()">
              <div>
                <span class="module-icon" [inlineSVG]="item.iconPath"></span>
                @if (dashboardMenuUncollapsed) {
                  <span class="ml-2">{{ item.label ?? (item.translation | transloco) }}</span>
                }
              </div>
              @if (dashboardMenuUncollapsed) {
                <div>
                  <div class="arrow" [ngClass]="{ closed: accordionItem.expanded }"></div>
                </div>
              }
            </div>
            <ng-container>
              <ul class="sub-menu" [ngClass]="{ expanded: accordionItem.expanded }">
                @for (childItem of item?.children; track trackByKey($index, childItem)) {
                  @if (childItem.children?.length) {
                    <!-- Third level. Its own cdk-accordion: inside the parent's one, opening it would close the parent. -->
                    <li
                      class="sub-menu-item sub-menu-group"
                      [exception]="menuItem"
                      [mobileOnly]="true"
                      (appClickOutside)="accordionItem.close()"
                    >
                      <cdk-accordion>
                        <cdk-accordion-item #nestedItem="cdkAccordionItem">
                          <!-- stopPropagation: on tablets every sibling's appClickOutside would close the parent group. -->
                          <div class="sub-menu-group-header" (click)="nestedItem.toggle(); $event.stopPropagation()">
                            <span class="d-flex align-items-center">
                              @if (childItem.iconPath) {
                                <span class="module-icon" [inlineSVG]="childItem.iconPath"></span>
                              }
                              <span>{{ childItem.label ?? (childItem.translation | transloco) }}</span>
                            </span>
                            <div class="arrow" [ngClass]="{ closed: nestedItem.expanded }"></div>
                          </div>
                          <ul class="sub-menu nested-sub-menu" [ngClass]="{ expanded: nestedItem.expanded }">
                            @for (grandchildItem of childItem.children; track trackByKey($index, grandchildItem)) {
                              <li class="sub-menu-item" (click)="interacted(accordionItem)">
                                <a
                                  [routerLink]="[grandchildItem.route]"
                                  routerLinkActive="active"
                                  [routerLinkActiveOptions]="{ exact: true }"
                                >
                                  <span>{{ grandchildItem.label ?? (grandchildItem.translation | transloco) }}</span>
                                </a>
                              </li>
                            }
                          </ul>
                        </cdk-accordion-item>
                      </cdk-accordion>
                    </li>
                  } @else {
                    <li
                      class="sub-menu-item"
                      (click)="interacted(accordionItem)"
                      [exception]="menuItem"
                      [mobileOnly]="true"
                      (appClickOutside)="accordionItem.close()"
                    >
                      <a
                        [routerLink]="[childItem.route]"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                      >
                        @if (childItem.iconPath) {
                          <span class="module-icon" [inlineSVG]="childItem.iconPath"></span>
                        }
                        <span> {{ childItem.label ?? (childItem.translation | transloco) }} </span>
                      </a>
                    </li>
                  }
                }
              </ul>
            </ng-container>
          </cdk-accordion-item>
        </cdk-accordion>
      } @else {
        <div class="menu-item" [routerLink]="[item.route]" routerLinkActive="active">
          <div class="d-flex">
            <span class="module-icon" [inlineSVG]="item.iconPath"></span>
            @if (dashboardMenuUncollapsed) {
              <span class="ml-2">{{ item.label ?? (item.translation | transloco) }}</span>
            }
          </div>
        </div>
      }
    }
  </div>
</div>
